import { Params } from '@angular/router';
import { WizardStepDTO } from '@api/models/';

export interface StepDataModel {
  step: WizardStepDTO;
  params?: Params;
}
